/**
 * @param  {Product} product
 * @return {String}  comma separated list of drms from drm object
 */

const capitalize = tag => tag.charAt(0).toUpperCase() + tag.slice(1);

export default (product) => {
  if (!product.drm) { return undefined; }

  if (Array.isArray(product.drm)) {
    return product.drm
      .sort((a, b) => a.localeCompare(b))
      .map(capitalize)
      .join(',');
  }

  return Object.keys(product.drm)
    .sort((a, b) => a.localeCompare(b))
    .filter(k => product.drm[k])
    .map(capitalize)
    .join(',');
};
